// Teams: Auswahl für „Mitglied hinzufügen“ – alle Profile ohne Archivierte, die noch nicht im Team sind
// (wie bisher in TeamsVerwaltung; Reihenfolge der Profilliste bleibt).
import { ohneArchivierte } from './archiv';

export function kandidaten<T extends { id: string; status?: string | null }>(alle: readonly T[], mitglieder: readonly { id: string }[]): T[] {
  const ids = new Set(mitglieder.map(m => m.id));
  return ohneArchivierte(alle).filter(p => !ids.has(p.id));
}

/** „1 Mitglied“ / „N Mitglieder“. */
export const mitgliederText = (n: number): string => `${n} ${n === 1 ? 'Mitglied' : 'Mitglieder'}`;
